import { render, staticRenderFns } from "./textDrag_echo_2.vue?vue&type=template&id=7de3e074&scoped=true"
import script from "./textDrag_echo_2.vue?vue&type=script&lang=js"
export * from "./textDrag_echo_2.vue?vue&type=script&lang=js"
import style0 from "./textDrag_echo_2.vue?vue&type=style&index=0&id=7de3e074&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de3e074",
  null
  
)

export default component.exports